"use strict"; // Start of use strict
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = js_swiper_url;
  s.async=true;
  s.onload = function(){ init_carousel(); init_featured();};
  document.getElementsByTagName('head')[0].appendChild(s);

  function init_carousel(){

    var swiper = new Swiper(".features-slide-Swiper", {
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 4.2,
            spaceBetween: 15,
          },
        },
    });
  }

  function init_featured() {
    const featured = document.querySelectorAll(".section-featured-collection");

    featured.forEach((item, index) => {
      const div = item.querySelector(".featured-section-div");
      if (!div) return;

      const returnId = div.dataset.id; // cleaner than getAttribute
      if (!returnId) return;
      const classTabs = `.${returnId}-features-slide-Swiper`;
      const prev = `.swiper-button-prev-${returnId}`;
      const next = `.swiper-button-next-${returnId}`;

      new Swiper(classTabs, {
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
          el: `${classTabs} .swiper-pagination`, // safer per swiper
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4.2,
          },
        },
      });
    });
  }
